import React, { useState,useEffect } from "react";
import { FaSave } from "react-icons/fa";
import { AiOutlineDownload } from "react-icons/ai";
import DeleteConfirmation from './ConfirmDelete';
import { formatDateForInput } from "../utils/dateFormat"; // adjust path as needed

import TimePicker from "./TimePicker";  // Import the custom TimePicker component
import { format } from "date-fns";     // Import date-fns for time formatting
import { FaPlusCircle } from "react-icons/fa";
import { FaTrash } from "react-icons/fa";
import AddRetailItem from '../components/AddRetailItem';
import RetailItemRow from '../components/RetailItemRow';
const BillComponent = ({ registrationForm, setRegistrationForm,saveForm,handleSubmit,handleDownload,addItem,handleItemDelete,editItem }) => {
    
    const [errors,setErrors]=useState([]);
    
    
    function getValidTime(ct) {
      const timePattern = /^(0?[1-9]|1[0-2]):[0-5][0-9]\s?(AM|PM)$/i;
      return timePattern.test(ct) ? ct : '';
  }  
 const [showModal, setShowModal] = useState(false);
      

  if (!registrationForm) return <p>Loading...</p>;

 
  const handleChange = (e, field, nestedField = null) => {
    let { value } = e.target;
  
    setRegistrationForm((prev) => {
     
      if(field==="no_of_days")
      {
        if (value === "" || isNaN(value)) {
          value = 0; // Handle blank or non-number
        } else if (value < 0) {
          value = 0; // Negative values corrected to 0
        }
      
         const updatedForm = {
          ...prev,
          [field]: value,
        };
    
        
          const rate = prev.rate || 0;
          const amountetax= value * rate;
          const igstAmount=(prev.igst_percent||0)* amountetax/100;
          const sgstAmount=(prev.sgst_percent||0)* amountetax/100;
          const cgstAmount=(prev.cgst_percent||0)* amountetax/100;
          const totalAmount=Math.round(amountetax+igstAmount+cgstAmount+sgstAmount);
          updatedForm.amount =amountetax;
          updatedForm.total_amount =totalAmount;
          updatedForm.igst_amount =igstAmount;
          updatedForm.sgst_amount =sgstAmount;
          updatedForm.cgst_amount =cgstAmount;
       
    
        return updatedForm;

      }
      if(field==="rate")
        {
           if(value<0)
           {
            value=0;
           }
           const updatedForm = {
            ...prev,
            [field]: value,
          };
      
          
            const noofdays = prev.no_of_days || 0;
            const amountetax = value * noofdays;
            const igstAmount=(prev.igst_percent||0)* amountetax/100;
          const sgstAmount=(prev.sgst_percent||0)* amountetax/100;
          const cgstAmount=(prev.cgst_percent||0)* amountetax/100;
          const totalAmount=Math.round(amountetax+igstAmount+cgstAmount+sgstAmount);
          updatedForm.amount =amountetax;
          updatedForm.total_amount =totalAmount;
          updatedForm.igst_amount =igstAmount;
          updatedForm.sgst_amount =sgstAmount;
          updatedForm.cgst_amount =cgstAmount;
      
          return updatedForm;
        }

        if(field==="igst_percent")
          {
             if(value<0)
             {
              value=0;
             }
             const updatedForm = {
              ...prev,
              [field]: value,
            };
        
            
              const amount = prev.amount || 0;
              const igstAmount = value * amount/100;
              const sgstAmount=prev.sgst_amount;
              const cgstAmount=prev.cgst_amount;
              const totalAmount=Math.round(amount+igstAmount+cgstAmount+sgstAmount);
              updatedForm.igst_amount = igstAmount;
              updatedForm.total_amount =totalAmount;
        
            return updatedForm;
          }

          if(field==="sgst_percent")
            {
               if(value<0)
               {
                value=0;
               }
               const updatedForm = {
                ...prev,
                [field]: value,
              };
          
              
                const amount = prev.amount || 0;
                const sgstAmount = value * amount/100;
                const igstAmount=prev.igst_amount;
                const cgstAmount=prev.cgst_amount;
                const totalAmount=Math.round(amount+igstAmount+cgstAmount+sgstAmount);
                updatedForm.sgst_amount = sgstAmount;
                updatedForm.total_amount =totalAmount;
             
          
              return updatedForm;
            }

            if(field==="cgst_percent")
              {
                 if(value<0)
                 {
                  value=0;
                 }
                 const updatedForm = {
                  ...prev,
                  [field]: value,
                };
            
                
                  const amount = prev.amount || 0;
                  const cgstAmount = value * amount/100;
                const igstAmount=prev.igst_amount;
                const sgstAmount=prev.sgst_amount;
                const totalAmount=Math.round(amount+igstAmount+cgstAmount+sgstAmount);
                updatedForm.cgst_amount = cgstAmount;
                updatedForm.total_amount =totalAmount;
               
            
                return updatedForm;
              }
    
  
      if (nestedField) {
        return {
          ...prev,
          [field]: {
            ...prev[field],
            [nestedField]: value,
          },
        };
      }
  
      return {
        ...prev,
        [field]: value,
      };
    });
  };

  const handleChangeCustom = (value, field) => {
    setRegistrationForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
  
  const validateRegistrationForm = (formData) => {
    let errors = [];
  
    // Required fields
    const requiredFields = [
    // "name" removed from here
    "checkin_date",
    "checkout_date",
    "no_of_days",
    "rate",
    "adults",
    "igst_percent",
    "sgst_percent",
    "cgst_percent",
    "issue_date",
    "gstin"
];

// 1. Check Standard Fields
requiredFields.forEach((field) => {
    if (formData[field] === undefined || formData[field] === null || formData[field].toString().trim() === "") {
        errors.push(`${field.replace(/_/g, ' ')} is required`);
    }
});

// 2. Special Check: Name OR Company Name
const hasName = formData.name && formData.name.toString().trim() !== "";
const hasCompany = formData.companyName && formData.companyName.toString().trim() !== "";

if (!hasName && !hasCompany) {
    errors.push("Either Guest Name or Company Name is required");
}

    if(formData.total_amount<=0){ errors.push(`Total billing amount must be greater than ZERO`);}
    return errors.length > 0 ? { isValid: false, errors } : { isValid: true };
  };

  const proceedToSubmit = () => {
    const validationResult = validateRegistrationForm(registrationForm);
  
    if (!validationResult.isValid) {
      setErrors(validationResult.errors);
    }
    else{
        setErrors([]);
        setShowModal(true);
    }

  
  };
  
  function toFixedDigit(n, noOfDigits) {
    return n.toString().padStart(noOfDigits, '0');
}

function toFixedDigitFloat(n, noOfDigit, noOfDigitAfterDecimal) {
    let [intPart, decimalPart] = n.toFixed(noOfDigitAfterDecimal).split("."); // Ensures decimal part has fixed digits
    intPart = intPart.padStart(noOfDigit, "0"); // Zero-pad the integer part
    return `${intPart}.${decimalPart}`;
}

function numberToWords(num) {
  if (num === 0) return "Zero";

  const units = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
  const teens = ["Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
  const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
  const scales = [
    { value: 10000000, name: "Crore" },
    { value: 100000, name: "Lakh" },
    { value: 1000, name: "Thousand" },
    { value: 100, name: "Hundred" }
  ];

  function helper(n) {
    let word = "";

    if (n < 10) word = units[n];
    else if (n < 20) word = teens[n - 10];
    else if (n < 100) word = tens[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + units[n % 10] : "");

    return word;
  }

  let result = "";
  let afterHundred = false; // flag to track if 'and' is needed

  for (const scale of scales) {
    if (num >= scale.value) {
      const scaledNum = Math.floor(num / scale.value);
      result += helper(scaledNum) + " " + scale.name + " ";
      num = num % scale.value;
      if (scale.value === 100) afterHundred = true;
    }
  }

  if (num > 0) {
    if (afterHundred) {
      result += "and ";
    }
    result += helper(num);
  }

  return result.trim();
}

  let abc=['3. ','',''];

  return (
    <div className="w-full max-w-4xl mx-auto p-1 bg-white shadow-md rounded-md text-sm">
      

      {/* Student Details */}
      <div className="flex flex-col gap-1 ">

       <div className="bg-purple-100 p-2">
       <div>
                <label><span></span>Bill Number</label>
                <p className="font-semibold">
                    {registrationForm.bill_number}
                </p>
                </div>
              </div>

        <div className="bg-green-100 p-2">
          <div>
          <label>Customer Name *</label>
          <input
            type="text"
            value={registrationForm.name || ""}
            onChange={(e) => handleChange(e, "name")}            
            onBlur={saveForm} 
disabled={
  registrationForm.submission_status?.toLowerCase() === "submitted" ||
  registrationForm.submission_status?.toLowerCase() === "cancelled"
}
  className={`mt-2 border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}
          />
        </div>

        
          <div className="mt-4">
        <label>Customer Address*</label>
        <textarea
        row="4"
          value={registrationForm.address || ""}
          onChange={(e) => handleChange(e, "address")}
          onBlur={saveForm} 
disabled={
  registrationForm.submission_status?.toLowerCase() === "submitted" ||
  registrationForm.submission_status?.toLowerCase() === "cancelled"
}
  className={`mt-2 border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}
        />
        </div>

<div className="mt-4">
          <label>Company Name *</label>
          <input
            type="text"
            value={registrationForm.companyName || ""}
            onChange={(e) => handleChange(e, "companyName")}            
            onBlur={saveForm} 
disabled={
  registrationForm.submission_status?.toLowerCase() === "submitted" ||
  registrationForm.submission_status?.toLowerCase() === "cancelled"
}
  className={`mt-2 border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}
          />
        </div>


        <div className="mt-4">
        <label>Company Address*</label>
        <textarea
        row="4"
          value={registrationForm.companyAddress || ""}
          onChange={(e) => handleChange(e, "companyAddress")}
          onBlur={saveForm} 
disabled={
  registrationForm.submission_status?.toLowerCase() === "submitted" ||
  registrationForm.submission_status?.toLowerCase() === "cancelled"
}
  className={`mt-2 border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}
        />
        </div>
        

        <div className="mt-4">
          <label>Customer GSTIN *</label>
          <input
            type="text"
            value={registrationForm.gstin || ""}
            onChange={(e) => handleChange(e, "gstin")}            
            onBlur={saveForm} 
disabled={
  registrationForm.submission_status?.toLowerCase() === "submitted" ||
  registrationForm.submission_status?.toLowerCase() === "cancelled"
}
  className={`mt-2 border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}
          />
        </div>

        <div className="mt-4">
          <label>Customer PAN</label>
          <input
            type="text"
            value={registrationForm.pan || ""}
            onChange={(e) => handleChange(e, "pan")}            
            onBlur={saveForm} 
disabled={
  registrationForm.submission_status?.toLowerCase() === "submitted" ||
  registrationForm.submission_status?.toLowerCase() === "cancelled"
}
  className={`mt-2 border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}
          />
        </div>


      </div>

      


      <div className="bg-pink-100 p-2">
      <div>
          <label>Room No</label>
          <input
            type="text"
            value={registrationForm.room_no || ""}
            onChange={(e) => handleChange(e, "room_no")}            
            onBlur={saveForm} 
disabled={
  registrationForm.submission_status?.toLowerCase() === "submitted" ||
  registrationForm.submission_status?.toLowerCase() === "cancelled"
}
  className={`mt-2 border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}
          />
        </div>

        <div className="mt-4">
          <label>No of Adults</label>
          
          <input
            type="text"
            value={registrationForm.adults || ""}
            onChange={(e) => handleChange(e, "adults")}            
            onBlur={saveForm} 
disabled={
  registrationForm.submission_status?.toLowerCase() === "submitted" ||
  registrationForm.submission_status?.toLowerCase() === "cancelled"
}
  className={`mt-2 border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}
          />
        </div>

        <div className="mt-4">
          <label>No of Children</label>
          
          <input
            type="text"
            value={registrationForm.children || ""}
            onChange={(e) => handleChange(e, "children")}            
            onBlur={saveForm} 
disabled={
  registrationForm.submission_status?.toLowerCase() === "submitted" ||
  registrationForm.submission_status?.toLowerCase() === "cancelled"
}
  className={`mt-2 border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}
          />
        </div>
      </div>


      <div className="bg-blue-100 p-2">
      <div>
          <label>CheckIn Date*</label>
          <input
            type="date"
            value={formatDateForInput(registrationForm.checkin_date)}  
            onChange={(e) => handleChange(e, "checkin_date")}
            onBlur={saveForm} 
disabled={
  registrationForm.submission_status?.toLowerCase() === "submitted" ||
  registrationForm.submission_status?.toLowerCase() === "cancelled"
}
  className={`border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}
          />
        </div>

        <div className="mt-4">
          <label>CheckIn Time*</label>
          {registrationForm.submission_status !== "submitted" && registrationForm.submission_status !== "cancelled" && (<TimePicker
          value={registrationForm.checkin_time}
          onChange={(value) => handleChangeCustom(value, "checkin_time")}
          saveForm={saveForm}
        />)}
       {registrationForm.submission_status === "submitted" && (<p>
          {getValidTime(registrationForm.checkin_time)}
        </p>)}
        </div>
     
      <div className="mt-4">
          <label>CheckOut Date*</label>
          <input
            type="date"
            value={formatDateForInput(registrationForm.checkout_date)}  
            onChange={(e) => handleChange(e, "checkout_date")}
            onBlur={saveForm} 
disabled={
  registrationForm.submission_status?.toLowerCase() === "submitted" ||
  registrationForm.submission_status?.toLowerCase() === "cancelled"
}
  className={`border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}
          />
        </div>

        <div className="mt-4">
          <label>CheckOut Time*</label>
          {registrationForm.submission_status !== "submitted" && registrationForm.submission_status !== "cancelled" && (<TimePicker
          value={registrationForm.checkout_time}
          onChange={(value) => handleChangeCustom(value, "checkout_time")}
          saveForm={saveForm}
        />)}
        {registrationForm.submission_status === "submitted" && (<p>
          {getValidTime(registrationForm.checkout_time)}
        </p>)}
       
        </div>
      </div> 
      <div className="bg-green-100">
        <div className="w-full bg-green-100 flex justify-center items-center p-1">
          <p className="text-lg font-bold ">ITEMS</p>
          
        </div>
        {registrationForm.submission_status!=='submitted' && registrationForm.submission_status !== "cancelled" &&(<div>
          <AddRetailItem
            addItem={addItem}
          />
          </div>)}
       
          
        {registrationForm.items && registrationForm.items.length>0 &&(<div className="flex w-full flex-wrap gap-1 justify-center items-center bg-white ">

       

        {registrationForm.items.map((item, index) => (
  <RetailItemRow key={index} item={item} index={index} handleItemDelete={handleItemDelete} submission_status={registrationForm.submission_status} editItem={editItem}/>
))}
 


        </div>)}
        
        {(!registrationForm.items || registrationForm.items.length<=0) &&(<p className="w-full text-center p-3 text-red-700 font-semibold">No Items In the Invoice. Add Items to Proceed</p>)}

        <div className="bg-blue-100 p-2">
      <div>
          <label>Total Billing Amount</label>
         <p className="font-semibold text-gray-900">{toFixedDigitFloat(registrationForm.total_amount||0,1,2)}</p>
         <p className="font-semibold text-gray-900">Rupees {numberToWords(registrationForm.total_amount||0)} Only</p>
        </div>

        </div>
        </div>
    

      

<div className="bg-green-100 p-2">
      <div>
          <label>Invoice Date*</label>
          <input
            type="date"
            value={formatDateForInput(registrationForm.issue_date)}  
            onChange={(e) => handleChange(e, "issue_date")}
            onBlur={saveForm} 
disabled={
  registrationForm.submission_status?.toLowerCase() === "submitted" ||
  registrationForm.submission_status?.toLowerCase() === "cancelled"
}
  className={`border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}
          />
        </div></div>
        </div>
      {errors.length > 0 && (
  <div className="bg-gray-100 p-2 rounded-lg shadow-md w-full border border-gray-300 mt-3 flex flex-col">
    {errors.map((error, index) => (
      <p key={index} className="text-red-600 text-sm">
        {error}
      </p>
    ))}
  </div>
)}  


<DeleteConfirmation
              isOpen={showModal}
              onCancel={() => setShowModal(false)}
              onDelete={() => {
                setShowModal(false);
                //call the actual delete function
                handleSubmit();
              }}
            />    

<div className="bg-gray-100 p-2 rounded-lg shadow-md w-full border border-gray-300 mt-3 flex flex-wrap justify-around ">


{registrationForm.submission_status!=='submitted' && registrationForm.submission_status!=='cancelled' &&(<button
  onClick={proceedToSubmit}
  className="flex items-center gap-2 px-4 py-2 text-white text-xs rounded-lg shadow-md transition duration-300 
             bg-green-600 hover:bg-green-700 m-1"
>
  <FaSave className="w-5 h-5" />
  SUBMIT
</button>)}
{registrationForm.submission_status==='submitted' &&(<button
  onClick={proceedToSubmit}
  className="flex items-center gap-2 px-4 py-2 text-white text-xs rounded-lg shadow-md transition duration-300 
             bg-gray-500 hover:bg-gray-500 m-1"
  disabled='true'
>
  <FaSave className="w-5 h-5" />
  SUBMITTED
</button>)}
{registrationForm.submission_status==='cancelled' &&(<button
  onClick={proceedToSubmit}
  className="flex items-center gap-2 px-4 py-2 text-white text-xs rounded-lg shadow-md transition duration-300 
             bg-gray-500 hover:bg-gray-500 m-1"
  disabled='true'
>
  <FaSave className="w-5 h-5" />
  CANCELLED
</button>)}

{true &&(<button
  onClick={handleDownload}
  className="flex items-center gap-2 px-4 py-2 text-white text-xs rounded-lg shadow-md transition duration-300 
             bg-orange-600 hover:bg-orange-700 m-1"
>
<AiOutlineDownload size={20} />
  BILL
</button>)}
</div>


    </div>
  );
};

export default BillComponent;
